import { memo, type ReactNode } from 'react';

import { ImageSearchIcon } from '@air/design-icons';

export type SearchCommandVisualSearchHeaderProps = {
  children?: ReactNode;
  titleId?: string;
};

export const SearchCommandVisualSearchHeader = memo(({ children, titleId }: SearchCommandVisualSearchHeaderProps) => (
  <div className="flex h-10 items-center py-2 pl-2">
    <span className="flex size-8 shrink-0 items-center justify-center">
      <ImageSearchIcon size="sm" className="ads:text-icon-emphasis text-gray-12" />
    </span>
    <span className="min-w-0 flex-1 font-semibold ads:text-primary text-14 text-gray-12" id={titleId}>
      Search visually
    </span>
    {children}
  </div>
));

SearchCommandVisualSearchHeader.displayName = 'SearchCommandVisualSearchHeader';
